import React from "react";
import type { FC } from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Flex, Money, Body } from "@edreamsodigeo/prisma-design-system";

import ContinueButton from "../../../common/ContinueButton/ContinueButton";
import type { NormalPriceSelectionBoxProps } from "../../contract";
import { useTrackingContext } from "../../PriceSelectionBoxTrackingProvider";

const NormalPriceSelectionBox: FC<NormalPriceSelectionBoxProps> = ({
  onContinueWithFlight,
  nonDiscountedPrice,
}) => {
  const { t } = useTranslation();
  const { trackOnContinueButtonClick } = useTrackingContext();

  const handleContinueButtonClick = (): void => {
    trackOnContinueButtonClick({ wasSelectedPrimePrice: false });
    onContinueWithFlight();
  };

  return (
    <Flex
      justifyContent={"space-between"}
      backgroundColor={"neutral.0"}
      data-testid={"normalPriceSelectionBox"}
      alignItems={"center"}
      width={"100%"}
      gap={"2"}
      px={"4"}
      py={"3"}
    >
      <Flex flexDirection={"column"} width={"65%"}>
        <Money size={"small"} rounded currency={nonDiscountedPrice.currency}>
          {nonDiscountedPrice.amount}
        </Money>
        <Body type={"xSmall"} color={"neutral.80"}>
          {t("equalProminence.normalPrice.priceDescription")}
        </Body>
      </Flex>
      <Flex flexDirection={"column"} width={"35%"}>
        <ContinueButton
          buttonText={t("equalProminence.continueBtn")}
          buttonType={"secondary"}
          onClick={handleContinueButtonClick}
        />
      </Flex>
    </Flex>
  );
};

export default NormalPriceSelectionBox;
